import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildIssuesGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const useIssue = buildIssuesGetterObject('useIssue');
export const useIssues = buildIssuesGetterObject('useIssues');

const getters = {
	[useIssues.getter]: (state) => state.issues,
	[useIssue.getter]: (state, getters) => (error_message) =>
		getters[useIssues.getter].find((issue) => issue.error_message === error_message),
};

export default getters;
